export enum SummarizerLengthEnum {
  Short = 'short',
  Medium = 'medium',
  Long = 'long',
}
